<template>
  <div
    class="detail-block"
    style="min-height: 600px"
  >
    <div class="hd">
      <div>客户标签</div>
      <el-button
        size="mini"
        plain
        @click="addLabel"
      >
        + 添加
      </el-button>
    </div>
    <div class="label-content">
      <div
        v-if="labelListData && labelListData.length > 0"
        class="label-lists"
      >
        <el-card
          v-for="(item, index) in labelListData"
          :key="index"
          shadow="never"
          class="label-card"
        >
          <div
            slot="header"
            class="clearfix"
          >
            <span>添加人：{{ item.salesperson_name }}</span>
            <span class="title-tips">添加时间：{{ getTime(item.add_time) }}</span>
            <el-tag
              v-if="item.is_quit"
              type="info"
              size="mini"
            >
              已离职
            </el-tag>
          </div>
          <div>
            <div
              v-if="item.company && item.company.length > 0"
              class="label-list"
            >
              <div class="label-title">
                企业标签
              </div>
              <SpLabelList
                :label-list="item.company"
                :readonly="true"
                tag-size="small"
              />
            </div>
            <div
              v-if="item.member && item.member.length > 0"
              class="label-list label-list-two"
            >
              <div class="label-title">
                个人标签
              </div>
              <SpLabelList
                :label-list="item.member"
                :readonly="true"
                tag-size="small"
              />
            </div>
          </div>
        </el-card>
      </div>
      <div
        v-else
        class="empty"
      >
        暂无数据
      </div>
    </div>

    <SpBatchLabel
      v-model="showBatchTagging"
      :selection-babel="true"
      :tags-list="tags"
      :show-selected-tags="true"
      @selectBabelList="selectBabelList"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    unionid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showBatchTagging: false,
      labelListData: [],
      tags: [],
      salespersonid: 0
    }
  },
  computed: {
    getTime () {
      return function (time) {
        return dayjs(time * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
    }
  },
  mounted () {
    this.initLabelList()
  },
  methods: {
    async initLabelList () {
      const data = await this.$api.customer.getTagsDetail({
        unionid: this.unionid
      })
      if (data) {
        this.labelListData = data
        let index = data.findIndex((v) => v.is_first === 1)
        this.tags = data[index].company || []
        this.salespersonid = data[index].salesperson_id || 0
      }
    },
    addLabel () {
      this.showBatchTagging = true
    },
    // 绑定标签
    async batchTagging (tagsList, tags_delete) {
      const data = await this.$api.customer.tagging({
        tags_id: tagsList.map((v) => v.id),
        unionid: this.unionid,
        tags_delete,
        salesperson_id: this.salespersonid
      })
      if (data && data.status) {
        this.showBatchTagging = false
        this.initLabelList()
        this.$message.success('打标签成功')
        this.tags = tagsList
      }
    },
    // 选定标签
    selectBabelList (tagsList) {
      let tags_delete = []
      this.tags.forEach((v) => {
        if (tagsList.findIndex((item) => item.id === v.id) === -1) {
          tags_delete.push(v.id)
        }
      })
      this.batchTagging(tagsList, tags_delete)
    }
  }
}
</script>

<style lang="scss" scoped>
.label-content {
  width: 100%;
  height: calc(100vh - 240px);
  overflow: auto;
  .empty {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
  }
  .label-lists {
    width: 100%;
    height: 100%;
    .title-tips {
      margin: 0 10px;
      font-size: 12px;
      color: #9a9097;
    }
    .label-card {
      margin-bottom: 20px;
      .label-list {
        .label-title {
          margin-bottom: 6px;
          line-height: 22px !important;
        }
      }
      .label-list-two {
        margin-top: 20px;
      }
    }
  }
}

.detail-block {
  width: 100%;
  margin-bottom: 10px;
  @include border-shadow();
  border-radius: 6px;
  padding: 20px;
  background: #fff;
  .hd {
    border-bottom: 1px solid $color-border-gray-light;
    margin-bottom: 20px;
    font-weight: 600;
    padding-bottom: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
